(function () {
  const initMainSlider = (section) => {
    if (!section || !section.classList.contains("featured-product-section")) {
      return;
    }

    const sliderEl = section.querySelector(".js-media-list");
    if (!sliderEl) return;

    const navPrev = sliderEl.querySelector(".swiper-button-prev");
    const navNext = sliderEl.querySelector(".swiper-button-next");
    const spaceBetween = sliderEl.classList.contains(
      "product__media-list--with-borders"
    )
      ? 1
      : 0;

    const initSwiper = () => {
      new Swiper(sliderEl, {
        slidesPerView: "auto",
        spaceBetween: spaceBetween,
        autoHeight: false,
        loop: false,
        direction: "horizontal",
        speed: 800,
        allowTouchMove: true,
        watchSlidesProgress: true,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: navNext,
          prevEl: navPrev,
        },
        on: {
          slideChange: function () {
            //window.pauseAllMedia();
            window.pauseAllModels();
            this.params.noSwiping = false;
          },
          slideChangeTransitionEnd: function () {
            const model3D =
              this.slides[this.activeIndex]?.querySelector("model-viewer");
            const posterBtn3D = this.slides[this.activeIndex]?.querySelector(
              ".shopify-model-viewer-ui__button--poster"
            );
            if (model3D && posterBtn3D) {
              posterBtn3D.removeAttribute("hidden");
            }
          },
          touchStart: function () {
            const model3D =
              this.slides[this.activeIndex]?.querySelector("model-viewer");
            if (model3D) {
              if (
                !model3D.classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });
    };

    initSwiper();
  };

  const initProductAccordion = (section) => {
    if (!section || !section.classList.contains("featured-product-section")) {
      return;
    }

    const accordions = section.querySelectorAll(".product-accordion");

    accordions.forEach((accordion) => {
      accordion.addEventListener("click", (event) => {
        const toggleEl = event.target.closest(".product-accordion__toggle");
        if (!toggleEl) return;

        const contentEl = toggleEl.nextElementSibling;
        if (
          !contentEl ||
          !contentEl.classList.contains("product-accordion__content")
        ) {
          return;
        }

        const isActive = toggleEl.classList.contains("active");
        if (!isActive) {
          slideDown(toggleEl, contentEl, 300); // func in global.js
        } else {
          slideUp(toggleEl, contentEl, 300); // func in global.js
        }
      });
    });
  };

  initMainSlider(document.currentScript.parentElement);
  initProductAccordion(document.currentScript.parentElement);

  document.addEventListener("shopify:section:load", (event) => {
    initMainSlider(event.target);
    if (!window.Shopify.designMode) {
      initProductAccordion(event.target);
    }
  });
})();
